package com.appsyde.shared.modules.ticket.domain.model

sealed class AssignTicketResult {
    data class Success(val ticketId: String, val assignedToAccountUserId: String, val assignedAt: String, val changed: Boolean) : AssignTicketResult()
    data class AssignedToOther(val assignedToAccountUserId: String, val assignedToDisplayName: String) : AssignTicketResult()
}
